/* global FormData */
import { useState, useCallback } from 'react';
import { resizeImage } from '../utils/resizeImage';

const SERVER_URL = process.env.REACT_APP_SERVER_URL || '';
const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

export function useFileUpload() {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);

  const uploadFile = useCallback(async (file, roomId) => {
    setError(null);

    // Downscale/recompress images before they ever hit the wire so we store
    // smaller files. Non-images and decode failures fall through untouched.
    const toUpload = await resizeImage(file);

    if (toUpload.size > MAX_FILE_SIZE) {
      const err = 'File too large (max 10MB)';
      setError(err);
      throw new Error(err);
    }

    setUploading(true);
    try {
      const token = localStorage.getItem('symphonate-token');
      const formData = new FormData();
      formData.append('file', toUpload);
      formData.append('roomId', roomId);

      const res = await fetch(`${SERVER_URL}/api/upload`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.error || 'Upload failed');
      }

      const data = await res.json();
      return data.attachment;
    } catch (e) {
      setError(e.message);
      throw e;
    } finally {
      setUploading(false);
    }
  }, []);

  return { uploadFile, uploading, error };
}
